import { render, staticRenderFns } from "./Video-1.vue?vue&type=template&id=4e92c61b&scoped=true"
import script from "./Video-1.vue?vue&type=script&lang=js"
export * from "./Video-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92c61b",
  null
  
)

export default component.exports